import { Link } from "react-router-dom";
import { navItems } from "./navItems";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-primary-100 mt-10">
      <div className="w-full px-4 md:px-6 py-10 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 text-lg">
                <i className="ri-cake-3-line"></i>
              </span>
              <span className="font-heading text-lg text-background-50">甜蜜惩罚动漫</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-100 max-w-md font-label">
              专注《甜蜜惩罚》的剧情梳理、角色档案与观看指南，为动漫爱好者提供清晰、完整、可检索的作品信息。
              本站为演示性质的内容站点，不提供播放与下载。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm mb-3 text-background-50">浏览页面</h3>
            <ul className="space-y-2">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-primary-100 hover:text-accent-300 transition-colors font-label cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm mb-3 text-background-50">联系我们</h3>
            <ul className="space-y-2 text-sm text-primary-100 font-label">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i> hello@sweet-punishment-anime.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line"></i> sweetpunishment_fans
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-music-2-line"></i> @sweetpunishment_anime
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-primary-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-primary-200 font-label">
            © 2025 甜蜜惩罚动漫 · 内容仅供学习交流演示使用
          </p>
          <p className="text-xs text-primary-200 font-label">
            本站不存储任何影片资源，版权归原作者及正版平台所有
          </p>
        </div>
      </div>
    </footer>
  );
}